'use es6';

import { enableMapSet } from 'immer';
import { App } from './App';
enableMapSet();
new App().start();